module.exports = __webpack_public_path__ + "static/media/proposal_verification_audio.c92bf440.mp3";